
//return secret key on call
export const Secret = () => {
 return "iamparbat9817890667";
}